import React, { useEffect, useState } from "react";
import { db, storage } from "../../firebase"; // naik 2 level
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import Swal from "sweetalert2";

export default function ManageVisiMisi() {
  const [visi, setVisi] = useState("");
  const [misi, setMisi] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load data awal
  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "profilSekolah", "main");
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const data = snap.data();
          setVisi(data.visi || "");
          setMisi(data.misi || []);
        } else {
          await setDoc(docRef, { visi: "", misi: [] });
        }
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Gagal mengambil data visi & misi", "error");
      }
    };
    fetchData();
  }, []);

  const handleMisiChange = (idx, value) => {
    const copy = [...misi];
    copy[idx] = value;
    setMisi(copy);
  };

  const addMisi = () => setMisi([...misi, ""]);
  const removeMisi = (idx) => setMisi(misi.filter((_, i) => i !== idx));

  const handleSave = async () => {
    setLoading(true);
    try {
      const docRef = doc(db, "profilSekolah", "main");
      await updateDoc(docRef, { visi, misi }).catch(async () => setDoc(docRef, { visi, misi }));
      Swal.fire("Berhasil", "Visi & Misi berhasil disimpan", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Gagal menyimpan Visi & Misi", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h3>Kelola Visi & Misi</h3>

      <div className="mb-3">
        <label className="form-label">Visi</label>
        <textarea
          className="form-control"
          rows={3}
          value={visi}
          onChange={(e) => setVisi(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Misi</label>
        {misi.map((item, idx) => (
          <div className="d-flex mb-2" key={idx}>
            <input
              className="form-control"
              value={item}
              onChange={(e) => handleMisiChange(idx, e.target.value)}
            />
            <button className="btn btn-danger ms-2" onClick={() => removeMisi(idx)}>
              Hapus
            </button>
          </div>
        ))}
        <button className="btn btn-secondary mt-2" onClick={addMisi}>
          Tambah Misi
        </button>
      </div>

      <button className="btn btn-primary mt-3" onClick={handleSave} disabled={loading}>
        {loading ? "Menyimpan..." : "Simpan Perubahan"}
      </button>
    </div>
  );
}
